module.exports = __webpack_public_path__ + "static/main-01ee7fdd5f35c2e5b1b71b3f4aa7c9c2.mp4";